export enum typeActiviteTypes {
    LOADING = "LOADING",
    SELECTED_TYPE_ACTIVITE = "SELECTED_TYPE_ACTIVITE",
    GET_TYPE_ACTIVITE_LIST = "GET_TYPE_ACTIVITE_LIST",
}
  
export default typeActiviteTypes;